import React, { useContext, useEffect, useMemo } from "react";
import { useVendingData } from "../hooks/useVendingData";

export const VendingContext = React.createContext();

export const VendingProvider = ({ children }) => {
  const vendingState = useVendingData();
  const value = useMemo(() => vendingState, [vendingState]);

  /* useEffect(() => {
    console.log("VendingProvider => ", value);
  }, [value]); */

  return <VendingContext.Provider value={value}>{children}</VendingContext.Provider>;
};

export function useVendingContext() {
  return useContext(VendingContext);
}
